module.exports = {"id":"173771","name":"Łukasz Piszczek","rating":"83","photo":"./data/images/photos/2/173771.png","club":{"name":"Bor. Dortmund","logo":"./data/images/clubs/Bor.Dortmund.png"},"positions":["DD","DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ŁukaszPiszczek0.json
// module id = 4480
// module chunks = 0